import { gql } from '@apollo/client';

export const CREATE_WAREHOUSE_PLANNING_ENTRY_CONFIGS = gql`
    mutation CreateWarehousePlanningEntryConfigs($input: CreateWarehousePlanningEntryConfigInput!) {
        result: createWarehousePlanningEntryConfigs(input: $input) {
            successCount
            skippedWarehouses
            skippedCount
        }
    }
`;

export interface CreateWarehousePlanningEntryConfigInput {
    warehouseIds: number[];
    entryNode: string;
    isActive: boolean;
    splitOrderConfig?: number[];
    templateEditStartTime?: string;
    templateEditEndTime?: string;
}

export interface CreateWarehousePlanningEntryConfigsResult {
    successCount: number;
    skippedWarehouses: string[];
    skippedCount: number;
}

export interface CreateWarehousePlanningEntryConfigResponse {
    result: CreateWarehousePlanningEntryConfigsResult;
}

